module.exports = __webpack_public_path__ + "src/assets/images/landingV2/business/oa-image-1.png";